import { request } from './api';
import type { TranslationResult } from '@atlas/shared';

export const translationApi = {
  /** Idempotent + pollable. Returns a TranslationResult (pending/completed/failed). */
  translate: (messageId: string, targetLanguage: string) =>
    request<TranslationResult>(`/messaging/messages/${messageId}/translate`, {
      method: 'POST',
      body: JSON.stringify({ targetLanguage }),
    }),
};
